/**
 * Textarea “focus” end of the selection — the end where the caret is drawn for range selections.
 * Mirrors `HTMLTextAreaElement.selectionDirection` semantics used by the editor shell.
 */
export function focusCaretOffsetFromSelection(
  selectionStart: number,
  selectionEnd: number,
  selectionDirection: string,
): number {
  const start = selectionStart;
  const end = selectionEnd;
  if (start === end) return end;
  return selectionDirection === "backward" ? start : end;
}
